// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"462":"ee225c5a","488":"9a3ad5d9","584":"7fb167ad","585":"b9a9c7c2","703":"b13f1016"}[chunkId] + ".chunk.js";
};